export const formatAsKey = (str: string) => {
  return str.trim().toLowerCase().replace(/ /g, '-').replace(/[,:]/g, '')
}

export const formatAsKeyFromCamelCase = (str: string) => {
  return formatAsKey(str.replace(/([A-Z(])/g, ' $1').trim())
}